import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { _t } from 'utils';
import { VALIDATION } from 'constant';

export default ({
  isCancel = false,
  onCancel,
  group: groupEdit = {},
}) => {
  const { id, properties = {} } = groupEdit;

  const group = {
    name: '',
    createDataCenter: false,
    createSnapshot: false,
    reserveIp: false,
    accessActivityLog: false,
    s3Privilege: false,
    createBackupUnit: false,
    ...properties,
  };

  const groupFields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'createDataCenter',
      type: 'switch',
      title: _t('Can Create Data Center?'),
    },
    {
      name: 'createSnapshot',
      type: 'switch',
      title: _t('Can Create Snapshot?'),
    },
    {
      name: 'reserveIp',
      type: 'switch',
      title: _t('Can Reserve IP?'),
    },
    {
      name: 'accessActivityLog',
      type: 'switch',
      title: _t('Can Access Activity Log?'),
    },
    {
      name: 's3Privilege',
      type: 'switch',
      title: _t('Can Access S3?'),
    },
    {
      name: 'createBackupUnit',
      type: 'switch',
      title: _t('Can Create Backup Unit?'),
    },
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      max: 63,
    },
  ];

  const onSave = (values) => {
    if (id) {
      actions.group.update({ id, group: { properties: values } });
      if (onCancel) {
        onCancel();
      }
    } else {
      actions.group.create({ group: { properties: values } });
    }
  };


  return (
    <>
      <Shared.forms.Form
        fields={groupFields}
        fieldsValues={group}
        onSubmit={onSave}
        isCancel={isCancel}
        onCancel={onCancel}
        validations={validations}
      />
    </>
  );
};
